import { render, staticRenderFns } from "./contentbox.vue?vue&type=template&id=5a41e806&scoped=true"
import script from "./contentbox.vue?vue&type=script&lang=js"
export * from "./contentbox.vue?vue&type=script&lang=js"
import style0 from "./contentbox.vue?vue&type=style&index=0&id=5a41e806&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a41e806",
  null
  
)

export default component.exports